import { render, staticRenderFns } from "./appCorrtoAdvID.vue?vue&type=template&id=3db2cf43&"
import script from "./appCorrtoAdvID.vue?vue&type=script&lang=js&"
export * from "./appCorrtoAdvID.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3db2cf43')) {
      api.createRecord('3db2cf43', component.options)
    } else {
      api.reload('3db2cf43', component.options)
    }
    module.hot.accept("./appCorrtoAdvID.vue?vue&type=template&id=3db2cf43&", function () {
      api.rerender('3db2cf43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/appCorrtoAdvID.vue"
export default component.exports